import React from 'react';

/**
 * Reusable Status Badge Component
 * Provides consistent status styling across the application
 * 
 * @param {string} status - Status value to display
 * @param {string} variant - Badge variant: 'default', 'pill', 'outline'
 * @param {string} className - Additional CSS classes
 */
const StatusBadge = ({ status, variant = 'default', className = '' }) => {
  // Status color mapping
  const getStatusStyles = (status) => {
    const statusLower = (status || '').toLowerCase();
    
    if (statusLower.includes('completed') || statusLower.includes('success') || statusLower.includes('ready')) {
      return 'text-green-600 bg-green-50 dark:text-green-400 dark:bg-green-900/20';
    }
    if (statusLower.includes('ongoing') || statusLower.includes('active') || statusLower.includes('in-progress')) {
      return 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/20';
    }
    if (statusLower.includes('yet to start') || statusLower.includes('upcoming') || statusLower.includes('scheduled')) {
      return 'text-purple-600 bg-purple-50 dark:text-purple-400 dark:bg-purple-900/20';
    }
    if (statusLower.includes('hold') || statusLower.includes('pending') || statusLower.includes('warning')) {
      return 'text-yellow-600 bg-yellow-50 dark:text-yellow-400 dark:bg-yellow-900/20';
    }
    if (statusLower.includes('cancelled') || statusLower.includes('error') || statusLower.includes('failed')) {
      return 'text-red-600 bg-red-50 dark:text-red-400 dark:bg-red-900/20';
    }
    // Default
    return 'text-gray-600 bg-gray-50 dark:text-gray-400 dark:bg-gray-900/20';
  };

  const baseClasses = getStatusStyles(status);
  
  const variantClasses = {
    default: `px-2 py-1 rounded text-sm font-medium ${baseClasses}`,
    pill: `px-3 py-1 rounded-full text-sm font-medium ${baseClasses}`,
    outline: `px-2 py-1 rounded text-sm font-medium border-2 ${baseClasses.replace('bg-', 'border-').replace('text-', 'text-')}`
  };

  if (!status) return null;

  return (
    <span className={`${variantClasses[variant]} ${className}`}>
      {status}
    </span>
  );
};

export default StatusBadge;



